import type {Directive} from 'vue';
import {useDisplayMobile} from '@malt/utils';

let onResizeListener: (() => void) | null = null;

function onResize(el: HTMLElement, offset: number) {
    return () => {
        const {top} = el.getBoundingClientRect();
        el.style.maxHeight = `${window.innerHeight - (top + offset)}px`;
    };
}

const scrollable: Directive = {
    mounted(el, bindings) {
        const {isDisplayMobile} = useDisplayMobile();
        const desktopOnly = bindings.modifiers.desktop === true;
        if (isDisplayMobile.value && desktopOnly) {
            return;
        }

        onResizeListener = onResize(el, bindings.value.offset);
        onResizeListener();
        window.addEventListener('resize', onResizeListener);
    },
    beforeUnmount() {
        if (onResizeListener) {
            window.removeEventListener('resize', onResizeListener);
        }
    },
};

export {scrollable};
